export default class StatusBarBase{
  currentHeight = 0;
}